import Form from '@rjsf/mui';
import SelectWidget from './SelectWidget';
import RadioWidget from './RadioWidget';
import type { RegistryWidgetsType } from '@rjsf/utils';
import type { FormProps } from '@rjsf/core';
import CheckboxesWidget from './CheckboxesWidget';
import CheckboxWidget from './CheckboxWidget';
import RangeWidget from './RangeWidget';
import TextareaWidget from './TextareaWidget';
import TextWidget from './TextWidget';
import validator from '@rjsf/validator-ajv8';

const customWidgets: RegistryWidgetsType = {
  CheckboxesWidget: CheckboxesWidget,
  CheckboxWidget: CheckboxWidget,
  RadioWidget: RadioWidget,
  RangeWidget: RangeWidget,
  TextareaWidget: TextareaWidget,
  TextWidget: TextWidget,
  SelectWidget: SelectWidget,
};

const RJSForm: React.FC<FormProps<any>> = ({ children, ...otherProps }) => (
  <Form {...otherProps} validator={validator} widgets={customWidgets}>
    {children}
  </Form>
);

export default RJSForm;
